import React from "react";
import { Pill, Droplet, Syringe, Hand, Activity } from "lucide-react";

/**
 * Route-specific icon + accessible tooltip used across:
 *  - Regimen detail rows
 *  - Regimen builder rows
 *  - Treatment Calendar event chips
 *  - Anywhere a single drug administration is rendered
 *
 * The icon is purely informational — text labels still render alongside it
 * wherever space allows.
 */
const ROUTE_CONFIG = {
  Oral:         { Icon: Pill,    label: "Oral (tablet / capsule)",        cls: "bg-amber-100 text-amber-700" },
  Intravenous:  { Icon: Droplet, label: "Intravenous (IV drip / push)",  cls: "bg-sky-100 text-sky-700" },
  Subcutaneous: { Icon: Syringe, label: "Subcutaneous injection",        cls: "bg-emerald-100 text-emerald-700" },
  Intramuscular:{ Icon: Activity,label: "Intramuscular injection",       cls: "bg-rose-100 text-rose-700" },
  Topical:      { Icon: Hand,    label: "Topical (skin)",                cls: "bg-violet-100 text-violet-700" },
};

export function getRouteConfig(route) {
  return ROUTE_CONFIG[route] || { Icon: Pill, label: route || "Unknown route", cls: "bg-stone-100 text-stone-600" };
}

export default function RouteIcon({ route, size = "md", withLabel = false, className = "" }) {
  const cfg = getRouteConfig(route);
  const { Icon, label, cls } = cfg;
  const dims = size === "sm" ? "w-5 h-5" : size === "lg" ? "w-8 h-8" : "w-6 h-6";
  const iconDim = size === "sm" ? "w-3 h-3" : size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5";
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${className}`}
      title={label}
      aria-label={label}
      data-testid={`route-icon-${route || "unknown"}`}
    >
      <span className={`${dims} rounded-md flex items-center justify-center ${cls}`}>
        <Icon className={iconDim} />
      </span>
      {withLabel && <span className="text-sm">{route}</span>}
    </span>
  );
}
